import React from 'react';
import { Button } from 'react-bootstrap';
import AccessDeniedImage from '../../../Assets/Images/accessDenied.svg';
import useLogout from '../../../hooks/useLogout';
import useTheme from '../../../hooks/useTheme';
import styles from './AccessDenied.module.scss';

const AccessDenied = () => {
    const logout = useLogout();
    const theme = useTheme();
    const darkMode = theme === 'theme--dark';

    return (
        <div className={`${styles["main-page-not-found"]}`}>
            <img src={AccessDeniedImage} className={`${styles["image-page-not-found"]}`} alt="" />
            <h2 className={`mt-2 mb-3 ${styles.title}`}>Access Denied</h2>
            <p className={`mb-4 text-center ${styles.subtitle}`}>You do not have access to this Application. <br/>Please contact the administrator</p>
            <Button
                className="btn btn-primary mb-3"
                onClick={() => {
                    logout();
                }}
            >
                Go Back
            </Button>
        </div>
    );
};

export default AccessDenied;